import { combineReducers } from '@reduxjs/toolkit';
import { client, clientsListReducer } from './model';

export { useClient, useClients } from './model';

export { clientApi } from './api';

export const clientsReducer = combineReducers({ list: clientsListReducer, client: client.reducer });

export * from './client-action';
